import type {
  ProfilePrivacySettings,
  SaveProfilePrivacyInput,
} from "@tabbio/types";
import {
  deriveCvVisibilityDefaults,
  normalizeProfilePrivacySettings,
} from "@tabbio/utils/profile-privacy";

export function buildSettingsPrivacyInput(
  current: ProfilePrivacySettings,
  patch: Partial<ProfilePrivacySettings>,
  publicIndexingAcknowledged = false,
): SaveProfilePrivacyInput {
  const next = normalizeProfilePrivacySettings({ ...current, ...patch });
  const derived = deriveCvVisibilityDefaults(next);
  return {
    ...next,
    consentSource: "settings",
    publicIndexingAcknowledged:
      next.profileVisibility === "public" && publicIndexingAcknowledged,
    cvVisibilityDefaults: {
      ...next.cvVisibilityDefaults,
      showEmail: derived.showEmail,
      showPhone: derived.showPhone,
      showPhoto: derived.showPhoto,
    },
  };
}

export function isSettingsAccessExpired(
  expiresAt: string | null,
  now = Date.now(),
) {
  if (!expiresAt) return false;
  const expires = Date.parse(expiresAt);
  return !Number.isFinite(expires) || expires <= now;
}
